import { render, staticRenderFns } from "./Coupon_Orders.vue?vue&type=template&id=3b4beb88&scoped=true&"
import script from "./Coupon_Orders.vue?vue&type=script&lang=js&"
export * from "./Coupon_Orders.vue?vue&type=script&lang=js&"
import style0 from "./Coupon_Orders.vue?vue&type=style&index=0&id=3b4beb88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4beb88",
  null
  
)

export default component.exports